// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Revmn","messagesHeader":"styles_messagesHeader__Rg5p-","messageListing":"styles_messageListing__iyqJ1"};